export default "__VITE_ASSET__BGM4IecF__"